import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appDynamicComponentHost]',
    standalone: false
})
export class DynamicComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
